import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker, Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  Chip,
  InputAdornment,
  Avatar,
  Paper,
  Divider,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';

import countries from '../user/countries';
import { COMPANY_LOGO, REST_API, REST_API_END_POINT, UNITS, currentFacilityId, filteredOtherFacilityTypes } from 'src/constants/Defaultvalues';
import axios from 'axios';
import moment from 'moment';
import LoadingScreen from 'src/components/LoadingScreen';
import AddTimeAndMaterialProduct from './AddTimeAndMaterialProduct';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { MTimelineDot } from 'src/components/@material-extend';
import { supabase } from '../../../supabase/supabaseClient';
import MaterialFinishedProducts from 'src/pages/dashboard/MaterialFinishedProducts';
import { capitalCase } from 'change-case';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import Modal from '../../_dashboard/blog/ProjectModel';
import JobCost from '../../../pages/dashboard/receipe';
import AddNewProductionWorkFlow from '../../../pages/dashboard/AddNewProductionWorkFlow';

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

export default function Editproduct({modalInhouse, modalSelectedTab, modalIsTrafficCatalog, modalTimeAndMaterial,  onClose, selectedProductForCatalog, editProduct}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const in_house=modalInhouse || location.state?.inhouse
  const timeAndMaterial=modalTimeAndMaterial || location.state?.timeAndMaterial
  const isTrafficCatalog = modalIsTrafficCatalog || location.state?.isTrafficCatalog
  const selectedTab = modalSelectedTab || location.state?.selectedTab
  console.log('selectedTab', selectedTab)
  const listPage = location.state?.listPage ?? 0;
  const rowsPerPage = location.state?.rowsPerPage ?? 25;


  const id = searchParams.get('id');
  const prodId = selectedProductForCatalog
    ? (selectedProductForCatalog?.product_id || selectedProductForCatalog?.id)
    : parseInt(id);
  let prodData;
  const [product, setProduct] = useState([]);
  const [isProductionCatalog, setProductionCatalog] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [initialSubData, setInitialSubData] = useState([]);
  const [allSubCatData, setAllSubCatData] = useState([]);
  const [workflows, setWorkflows] = useState([])
  const [tags, setTags] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [recipe, setRecipe] = useState([])
  const [isRecipeLoading, setIsRecipeLoading] = useState(false)
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()

  // Browser back-button auto-save handling (minimal & non-invasive)
  const formikRef = useRef(null);
  const allowBrowserBackRef = useRef(false);
  const autoSaveThenGoBackRef = useRef(false);
  const backConfirmInProgressRef = useRef(false);
  const isCategoryInitializedRef = useRef(false);
  const [openBackConfirmDialog, setOpenBackConfirmDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [thumbnailLoading, setThumbnailLoading] = useState(false);
  const isEdit = false
  const [inHouse, setInHouse] = useState(in_house)
  const [loading,setLoading]=useState(false)
  const [timeMaterial,setTimeMaterial] = useState(timeAndMaterial)
  const [avaTaxCategory, setAvaTaxCategory] = useState([])
  const [otherInstallationSplitInstallLabour, setOtherInstallationSplitInstallLabour] = useState([])
  const [currentInstallationSplitManagementSettings, setCurrentInstallationSplitManagementSettings] = useState([])
  console.log('currentInstallationSplitManagementSettings', currentInstallationSplitManagementSettings)
  const [splitPercentage, setSplitPercentage] = useState(0)
  console.log('splitPercentage----------', splitPercentage)
  const [catalogStocks, setCatalogStocks] = useState([]);
  const [currentTab, setCurrentTab] = useState('Finished Products');
  const [vendors, setVendors] = useState([]);
  const [openRecipeModal, setOpenRecipeModal] = useState(false);
  const [openWorkflowModal, setOpenWorkflowModal] = useState(false);
  const [formulaFieldLoading, setFormulaFieldLoading] = useState({});

  const [newRecipeID,setNewRecipeID]= useState('')

  const setFormulaFieldsLoading = useCallback((fields, isLoading) => {
    setFormulaFieldLoading((prev) => {
      const next = { ...prev };
      fields.forEach((field) => {
        if (isLoading) {
          next[field] = true;
        } else {
          delete next[field];
        }
      });
      return next;
    });
  }, []);

  const getFormulaRefreshFieldKeys = useCallback(() => {
    const keys = [
      'recipe_id',
      'formula_cost',
      'retail_price',
      'install_cost',
      'product_cost_retail',
      'install_labour_cost',
    ];
    if (product?.inhouse === 6 || selectedTab === 'split_catalog') {
      keys.push('install_labour_quantity', 'install_labour_cost_with_markup');
    }
    return keys;
  }, [product?.inhouse, selectedTab]);

  const ACCOUNT_TABS = [
    // {
    //   value: 'Partial Finished Products',
    // },
    {
      value: 'Finished Products',
    },
  ];

  const fetchCatalogStocks = async (id) => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-catalog-stocks`, { catalog_id: id });
      if (response.data.status === 1) {
        setCatalogStocks(response.data.logs || []);
      } else {
        console.error('Failed to fetch catalog stocks');
      }
    } catch (error) {
      console.error('Error fetching catalog stocks:', error);
    }
  };

  useEffect(() => {
    fetchCatalogStocks(prodId);
  }, []);

  // Initialize split percentage and install labor cost for split catalog
  useEffect(() => {
    if ((product?.inhouse === 6 || selectedTab === 'split_catalog') && product?.facility_id && currentInstallationSplitManagementSettings.length > 0) {
      const splitSettings = currentInstallationSplitManagementSettings.find(
        setting => setting.id == currentFacilityId
      );
      
      if (splitSettings) {
        const facilitySplitPercentage = splitSettings.split_percentage || 0;
        setSplitPercentage(facilitySplitPercentage);
      }
    }
  }, [product?.facility_id, currentInstallationSplitManagementSettings, product?.inhouse, selectedTab]);


  // console.log('timeMaterialtimeMaterialtimeMaterial',timeMaterial);
  
  const findCategoryOptionById = (categories, categoryId) => {
    if (!categoryId || !Array.isArray(categories)) return null;
    return categories.find((item) => Number(item?.id) === Number(categoryId)) || null;
  };

  const resolveAssignedCategoryOption = (categories, editProduct, subCategories) => {
    const subRow = subCategories?.find((s) => Number(s.id) === Number(editProduct?.sub_category_id));
    const categoryId = Number(editProduct?.category_id || subRow?.category_id);
    if (!categoryId) return null;

    const fromDropdown = findCategoryOptionById(categories, categoryId);
    if (fromDropdown) return fromDropdown;

    const categoryName = String(
      editProduct?.category_name
      || editProduct?.category
      || subRow?.category_name
      || ''
    ).trim();
    if (!categoryName) return null;

    return {
      id: categoryId,
      name: categoryName,
      category_type: editProduct?.category_type_name ?? subRow?.category_type ?? 1,
      status: 1,
    };
  };

  const fetchAllProductCategory = async (editData) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const userType = user.user_type
      const userId = user.user_id
      axios
        .post(REST_API_END_POINT + 'product/get-all-product-categories',{userType,userId,isVendor:1})
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            const allCategories = data?.productCategories || [];
            const productionCategories = allCategories.filter((item) => item?.category_type == 1 && item.status == 1);
            let categoriesForDropdown = [...productionCategories];

            // Keep the product's assigned category in options even if category_type differs (e.g. transferred)
            if (editData?.category_id) {
              const assignedCategory = allCategories.find(
                (item) => Number(item?.id) === Number(editData.category_id)
              );
              if (assignedCategory && !categoriesForDropdown.some((item) => Number(item.id) === Number(assignedCategory.id))) {
                categoriesForDropdown.push(assignedCategory);
              }
            }

            const sortedCategories = [...categoriesForDropdown].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setCategoryData(sortedCategories)
            setVendors(data?.vendorData?.data || [])
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }
  }
  const getAllSubCategory = async (editData) => {
    try {
      axios.post(`${REST_API_END_POINT}product/get-all-sub-category`)
        .then((res) => {
          if (res.data.status === 1) {
            const allSubCat = res?.data?.data
            console.log('allSubCatallSubCat',allSubCat)
            const filteredSubCat = allSubCat?.filter((item)=>item.category_id == editData?.category_id) || []
            // Sort alphanumerically by name
            const sortedSubCat = [...filteredSubCat].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setSubCategory(sortedSubCat)
            setInitialSubData(sortedSubCat)
            setAllSubCatData(allSubCat)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }
  const getAllWorkflows = async () => {
    try {
      axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`)
        .then((res) => {
          // Sort alphanumerically by name
          const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setWorkflows(sortedWorkflows)
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }
  const filterSortRecipes = (recipesList = [], productSnapshot = null) => {
    const prod = productSnapshot || product
    const filteredData = (recipesList || []).filter((recipeItem) =>
      isTrafficCatalog
        ? recipeItem?.type === 2
        : (prod?.inhouse === 6 || selectedTab === 'split_catalog')
          ? recipeItem?.type === 3
          : recipeItem?.type === 1
    )
    return [...filteredData].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
  }

  const applyRecipeMeta = (data) => {
    if (data?.otherInstallationSplitInstallLabour) {
      setOtherInstallationSplitInstallLabour(data.otherInstallationSplitInstallLabour)
    }
    if (data?.currentFacilitySplitManagementSettings) {
      setCurrentInstallationSplitManagementSettings(data.currentFacilitySplitManagementSettings)
    }
  }

  const mergeRecipes = (existing = [], incoming = []) => {
    const byId = new Map()
    ;[...incoming, ...existing].forEach((r) => {
      if (r?.id != null) byId.set(Number(r.id), r)
    })
    return [...byId.values()].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
  }

  // catalogRecipeId + productSnapshot must be passed — product state is not updated yet on first mount
  const fetchAllRecipe = async (catalogRecipeId = null, productSnapshot = null) => {
    const recipeId = catalogRecipeId || productSnapshot?.recipe_id || product?.recipe_id || null
    try {
      setIsRecipeLoading(true)

      // Fire both calls together so Network shows 2 get-all-recipes:
      // 1) selected catalog formula (fast)  2) remaining formulas (background)
      const priorityPromise = recipeId
        ? axios.post(REST_API_END_POINT + 'product/get-all-recipes', { recipeId })
        : null

      const remainingPromise = axios.post(
        REST_API_END_POINT + 'product/get-all-recipes',
        recipeId ? { excludeRecipeId: recipeId } : {}
      )

      if (priorityPromise) {
        // Do not clear loading here — keep spinner on dropdown until remaining finishes.
        // Selected formula still appears as soon as this resolves via setRecipe.
        priorityPromise
          .then((firstRes) => {
            if (firstRes?.data?.status === 1) {
              const priority = filterSortRecipes(firstRes.data.recipes || [], productSnapshot)
              setRecipe((prev) => mergeRecipes(prev, priority))
            }
          })
          .catch((priorityError) => {
            console.error('Error fetching catalog product formula:', priorityError)
          })
      }

      const secondRes = await remainingPromise
      const data = secondRes.data
      if (data?.status === 1) {
        const remaining = filterSortRecipes(data.recipes || [], productSnapshot)
        setRecipe((prev) => mergeRecipes(prev, remaining))
        applyRecipeMeta(data)
      }
    } catch (e) {
      console.error('Exception:', e)
    } finally {
      setIsRecipeLoading(false)
    }
  }

  const fetchAllAvalaraTaxCategories = async()=>{
    try {
       const response = await axios.post(`${REST_API_END_POINT}avalara/get-all-tax-category`);
       console.log("fetchAllAvalaraTaxCategories",response?.data?.result)
       // Sort alphanumerically by description
       const sortedCategories = [...(response?.data?.result || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
       setAvaTaxCategory(sortedCategories)
    } catch (error) {
      console.error('Error fetching Avalara tax categories:', error);
      
    }
  }

  const uploadThumbnailToSupabase = async (file) => {
    try {
      setThumbnailLoading(true);
      const timestamp = Date.now();
      const sanitizedFileName = file.name.replace(/\s+/g, '_');
      const fileName = `${timestamp}_${sanitizedFileName}`;
      const filePath = `product-thumbnails/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const {
        data: publicUrlData,
        error: urlError,
      } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to generate public URL');
      }

      return publicUrlData.publicUrl;
    } catch (error) {
      console.error('Error uploading thumbnail to Supabase:', error);
      throw error;
    } finally {
      setThumbnailLoading(false);
    }
  };
  useEffect(async () => {
    // console.log("Product id----", prodId)
    setLoading(true)
   
    const response = await axios.post(`${REST_API_END_POINT}product/get-product-by-id?id=${prodId}`);
    if (response.data.status == 1) {
      prodData = response.data.result;
      const InitialTagsList = prodData[0]?.tags
      setTags(InitialTagsList?.split(',')?.map((tag) => tag?.trim())||[])
      setProduct(prodData[0]);
      // if(prodData[0].inhouse===1){
      //   setInHouse(true)
      // }
      // else{
      //   setInHouse(false)

      // }
      if(prodData[0].inhouse === 1){
        setProductionCatalog(true)
      }
      if (prodData[0].inhouse === 1 || prodData[0].inhouse === 4 || prodData[0].inhouse === 5 || prodData[0].inhouse === 6 || prodData[0].inhouse === 7) {
        setInHouse(true);
      } else {
        setInHouse(false);
      }

    }
    else {
      enqueueSnackbar('No matching data found', { variant: 'error' });
      if (editProduct && onClose) {
        onClose();
      }else{
        navigate(PATH_DASHBOARD.products.main);
      }
    }
    fetchAllProductCategory(prodData[0])
    getAllSubCategory(prodData[0])
    getAllWorkflows()
    fetchAllRecipe(prodData[0]?.recipe_id, prodData[0])
    fetchAllAvalaraTaxCategories()
    setTimeout(()=>{
      setLoading(false)
    },3000)
  }, [])
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required')
    .matches(/^[^\t\n\r:]+$/, 'Name cannot contain colons(:)')
    // .matches(/^[a-zA-Z0-9\s\-]+$/, 'Name can only contain letters, numbers, spaces, and hyphens')
,
    // price: inHouse&&Yup.number().typeError('Please enter a valid price').required('Wholesale Price is required'),
    retail_price: selectedTab != 'sub_contract' && (inHouse || isTrafficCatalog) && selectedTab !== 'split_catalog' &&
      Yup.number()
        .typeError('Please enter a valid price')
        .required('Retail Price is required')
        .test(
          'min-retail-price',
          'Actual Retail Price cannot be less than Product Cost (Retail)',
          function (retailPrice) {
            const { formula_cost, s_price, markupPrice } = this.parent;
            let productCostRetail;

            if (product?.inhouse === 6 || selectedTab === 'split_catalog') {
              productCostRetail = formula_cost ? Number(formula_cost) : 0;
            } else {
              const materialCost = typeof s_price === 'number' ? s_price : 0;
              const serviceCost = typeof markupPrice === 'number' ? markupPrice : 0;
              productCostRetail = materialCost + serviceCost;
            }
            
            // Ensure productCostRetail is a number for comparison
            productCostRetail = parseFloat(productCostRetail) || 0;

            // Helper to avoid floating point precision issues and always compare at 2 decimals
            const roundToTwo = (value) =>
              Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

            if (retailPrice === undefined || retailPrice === null || retailPrice === '') {
              return true; // Allow if retailPrice is not set yet
            }

            const roundedRetailPrice = roundToTwo(retailPrice);
            const roundedProductCost = roundToTwo(productCostRetail);

            return roundedRetailPrice >= roundedProductCost;
          }
        ),
    install_cost: Yup.number()
      .nullable()
      .typeError('Please enter a valid price')
      .when([], {
        is: () => (inHouse || isTrafficCatalog) && selectedTab !== 'sub_contract',
        then: Yup.number()
          .required('Install Price is required')
          .test(
            'min-install-price',
            'Actual Install Price cannot be less than Install Labor Cost',
            function (installCost) {
              const { recipe_id } = this.parent;

              // Same 2-decimal compare as Actual Retail (avoid .toFixed on one side only)
              const roundToTwo = (value) =>
                Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

              let laborCost = 0;
    
              if (recipe_id) {
                laborCost =
                  (product?.inhouse === 6 || selectedTab === 'split_catalog')
                    ? Number(recipe_id.expected_install_labor_cost || 0)
                    : Number(recipe_id.install_labour_cost_with_markup || 0);
              }
    
              console.log('installValidation==installLaborCost', laborCost);
              console.log('installValidation==installCost', installCost);
    
              if (installCost == null || installCost === '') return true;

              return roundToTwo(installCost) >= roundToTwo(laborCost);
            }
          ),
        otherwise: Yup.number().nullable()
      }),
    s_price: Yup.number().typeError('Please enter a valid price'),
    description: Yup.string().required('Description is required'),
    vpt_number:Yup.string().required('SKU is required'),
    category: Yup.object().nullable().required('Category is required'),
    sub_category: Yup.object().nullable().required('Sub Category is required'),
    workflows: Yup.object().nullable().required('Workflows is required'),
    recipe_id: (inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && Yup.object().nullable().required('Product Formula is required'),
    unit: Yup.object().nullable(),
    markup: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog') && Yup.number().required('Markup is required').nullable(),
    sub_contract_price: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog') && Yup.number().required('Price is required').nullable(),
    vendor: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog')
      ? Yup.string().required('Vendor is required').nullable()
      : Yup.string().nullable(),
    formula_cost: (inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && Yup.number().required('formula cost is required'),
    facility_id: (product?.inhouse === 6 || selectedTab === 'split_catalog') ? Yup.object().nullable().required('Facility Type is required') : Yup.object().nullable(),
    lead_time: Yup.number().typeError('Please enter a valid number').nullable(),
    // in_stock_no: Yup.string()
    //   .when([], {
    //     is: () => product?.inhouse === 4,
    //     then: Yup.string().required('Stock is required for Stock Catalogs'),
    //     otherwise: Yup.string().nullable(),
    //   }),
    // avatarUrl: Yup.mixed().required('Avatar is required')
  });




  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));
  //
const retail_cost = parseFloat(product.retail_price) || 0;
const install_cost = parseFloat(product.install_cost) || 0;
  const prod_name = (product.name) ? product.name : '';
  const prod_vpt_number = (product.vpt_number) ? product.vpt_number : '';
  const prod_price = (product.price) ? product.price : '';
  // Prefer catalog actual_retail_price; fall back to selected estimate-row value when opened as modal
  const sourceActualRetail =
    product?.actual_retail_price ??
    selectedProductForCatalog?.original_actual_retail_price ??
    selectedProductForCatalog?.actual_retail_price;
  // const prod_retail_price =
  //   sourceActualRetail != null && sourceActualRetail !== ''
  //     ? parseFloat(sourceActualRetail)
  //     : (retail_cost - install_cost);
  const sourceInstallCost =
    product?.install_cost ??
    selectedProductForCatalog?.original_install_cost ??
    selectedProductForCatalog?.install_cost;
  const prod_install_cost_raw =
    sourceInstallCost != null && sourceInstallCost !== ''
      ? parseFloat(sourceInstallCost)
      : 0;
  const prod_formula_cost = (product.formula_cost) ? product.formula_cost : '';
  const prod_pf_retail_markup = (product.pf_retail_markup) ? product.pf_retail_markup : '0.00';
  const prod_description = (product.description) ? product.description : '';
  const prod_thumbnail = (product.thumbnail) ? product.thumbnail : '';
  const prod_start_date = (product.start_date) ? moment.unix(product.start_date).format('MM-DD-YYYY') : null;
  const prod_end_date = (product.end_date) ? moment.unix(product.end_date).format('MM-DD-YYYY') : null;
  // const prod_special_price = (product.special_price) ? product.special_price : ''; previous
  const initialCategory = resolveAssignedCategoryOption(categoryData, product, allSubCatData);
  const initialUnit = (product.unit) ? UNITS?.find((data) => data.id === product.unit) : UNITS?.find((data) => data.id === 4);
  const prod_unitQty = (product.unit_qty) ? product.unit_qty : '';
  const initialSubCategory = product?.sub_category_id
    ? initialSubData?.find((data) => Number(data?.id) === Number(product?.sub_category_id))
    : null;
  const initialWorkFlow = (product?.workflow) ? workflows?.find((data) => data.id === product?.workflow) : null;
  const initialRecipe = (product?.recipe_id) ? recipe?.find((data) => data.id === product?.recipe_id) : null;
  let markupPrice= initialRecipe?.expected_service_cost_with_markup || 0
  const prod_special_price =  initialRecipe?.expected_material_cost_with_markup || 0
  // Formula Cost = Product Cost (Retail) + Install Labor when recipe is available
  const computed_formula_cost = initialRecipe
    ? (product?.inhouse === 6
        ? Number(initialRecipe?.expected_cost || prod_formula_cost || 0)
        : Number(
            (initialRecipe?.expected_material_cost_with_markup || 0)
            + (initialRecipe?.expected_service_cost_with_markup || 0)
            + (initialRecipe?.install_labour_cost_with_markup || 0)
          ))
    : prod_formula_cost;
  // Actual Retail Price must not be less than Product Cost (Retail).
  // If saved Actual Retail ≈ Formula Cost, it wrongly included install — use Product Cost instead.
  const clampActualRetailToProductCost = (savedActual, productCost, formulaCost) => {
    const cost = Number(productCost) || 0;
    let actual = Number.isFinite(Number(savedActual)) ? Number(savedActual) : 0;
    const formula = Number(formulaCost) || 0;
    if (
      !(product?.inhouse === 6 || selectedTab === 'split_catalog') &&
      formula > 0 &&
      Math.abs(actual - formula) < 0.05
    ) {
      actual = cost;
    }
    return Number(Math.max(actual, cost).toFixed(2));
  };
  const initialProductCostRetail = (product?.inhouse === 6 || selectedTab === 'split_catalog')
    ? (Number(computed_formula_cost) || Number(prod_formula_cost) || 0)
    : ((Number(prod_special_price) || 0) + (Number(markupPrice) || 0));
  const prod_retail_price_raw =
    sourceActualRetail != null && sourceActualRetail !== ''
      ? parseFloat(sourceActualRetail)
      : (retail_cost - install_cost);
  const prod_retail_price = clampActualRetailToProductCost(
    prod_retail_price_raw,
    initialProductCostRetail,
    computed_formula_cost || prod_formula_cost
  );
  // Actual Install Price must not be less than Install Labor Cost (same rule as Yup min-install-price)
  const initialInstallLaborCost = initialRecipe
    ? ((product?.inhouse === 6 || selectedTab === 'split_catalog')
        ? Number(initialRecipe?.expected_install_labor_cost || 0)
        : Number(initialRecipe?.install_labour_cost_with_markup || 0))
    : 0;
  const prod_install_cost = Number(Math.max(
    Number.isFinite(prod_install_cost_raw) ? prod_install_cost_raw : 0,
    initialInstallLaborCost || 0
  ).toFixed(2));
  const prod_markup = (product.markup) ? product.markup : null;
  const prod_sub_contract_price = (product.sub_contract_price) ? product.sub_contract_price : null;
  const prod_in_stock_no = product?.in_stock_no ?? 0;
  const prod_inhouse_no = product?.inhouse || '';
  const prod_taxCodeId = (product.taxCodeId) ? product.taxCodeId : null;
  const product_taxCode = (product.taxCode) ? product.taxCode : null;
  const prod_lead_time = (product.lead_time) ? product.lead_time : '';
  const prod_bin_location = (product.bin_location) ? product.bin_location : '';
  const prod_vendor_id = product?.vendor_id
    ? String(String(product.vendor_id).split(',')[0]).trim()
    : '';
  const product_inhouse =  product?.inhouse 
  let expectedPrice = product_inhouse == 0 ? prod_sub_contract_price || 0 : prod_retail_price;

  if (product_inhouse == 0) {
    const price = Number(prod_sub_contract_price) || 0;
    const markup = Number(prod_markup) || 0;
    expectedPrice = price + (price * ( markup / 100));
  }
  // Helper function to get install labor cost based on facility_id
  const getInstallLaborCost = (facilityId) => {
    if (!facilityId || !otherInstallationSplitInstallLabour.length) return null;
    const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
      item => item.facility_id == facilityId
    );
    return filteredInstallLabour.length > 0 ? filteredInstallLabour[0].total_cost : null;
  };
 
  console.log("###############initialRecipe",initialRecipe);
  console.log("###############markupPrice",markupPrice);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: prod_name,
      // price: prod_price,
      price: null,
      retail_price: prod_retail_price,
      install_cost: prod_install_cost,
      formula_cost: computed_formula_cost !== '' && computed_formula_cost != null
        ? Number(computed_formula_cost).toFixed(2)
        : prod_formula_cost,
      s_price: prod_special_price,
      description: prod_description,
      vpt_number: prod_vpt_number,
      ul_number: product?.ul_number || '',
      start: prod_start_date,
      markupPrice:markupPrice,
      end: prod_end_date,
      category: initialCategory,
      unit: initialUnit,
      unit_qty:prod_unitQty,
      sub_category: initialSubCategory,
      workflows: initialWorkFlow,
      recipe_id: initialRecipe,
      // avatarUrl: `${REST_API}build/images/products/${prod_thumbnail}`,
      avatarUrl: COMPANY_LOGO,
      thumbnail: prod_thumbnail,
      pf_retail_markup:prod_pf_retail_markup,
      isTrafficCatalog:isTrafficCatalog,
      markup :prod_markup,
      sub_contract_price: prod_sub_contract_price,
      in_stock_no: prod_in_stock_no,
      prod_inhouse_no: prod_inhouse_no,
      taxCodeId:prod_taxCodeId || null,
      taxCode: product_taxCode || '',
      lead_time: prod_lead_time,
      bin_location: prod_bin_location,
      facility_id: product?.facility_id ? filteredOtherFacilityTypes?.find(f => f.id === product.facility_id) : null,
      install_labour_quantity: product?.install_labour_quantity || 0,
      install_labour_cost_with_markup: getInstallLaborCost(product?.facility_id) || product?.install_labour_cost_with_markup || null,
      expected_cost: product?.expected_cost || 0,
      vendor: prod_vendor_id,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      try {
        const shouldGoBackAfterSave = autoSaveThenGoBackRef.current;
        const user = localStorage.getItem('user')
        const userData = JSON.parse(user)
        // if((values?.unit?.id) && (values?.unit?.id !== 4) && (values?.unit_qty == '')){
        //   setFieldError('unit_qty',`Please enter the number of ${values?.unit?.name}`)
        // }else{
          values.id = userData.user_id
          values.tags = tags?.join(',')
          // await fakeRequest(500);
          if (values.start) {
            values.start = moment(values.start).valueOf() / 1000; //converting start date to timestamp
            // console.log("converted values.start", values.start)
            if (isNaN(values.start)) {
              values.start = ''; //initializing the date when converted date is not a number
            }
          }
          else {
            values.start = ''; //initializing the date if date not available
          }
          if (values.end) {
            values.end = moment(values.end).valueOf() / 1000; //converting end date to timestamp
            // console.log("converted values.end", values.end)
            if (isNaN(values.end)) {
              values.end = ''; //initializing the date when converted date is not a number
            }
          }
          else {
            values.end = ''; //initializing the date if date not available
          }
          // console.log("selectedFile : ", selectedFile)
          /*******************************************************************************************************/
          // Upload thumbnail to Supabase if selected
          let thumbnail = values.thumbnail || 'default.jpg'; // Keep existing thumbnail or use default if none
          if (selectedThumbnail) {
            try {
              thumbnail = await uploadThumbnailToSupabase(selectedThumbnail);
            } catch (error) {
              enqueueSnackbar('Failed to upload thumbnail', { variant: 'error' });
              setSubmitting(false);
              return;
            }
          }

          //Appending values to formData
          const formData = new FormData();
          formData.append("added_by", values.id);
          formData.append("thumbnail", thumbnail);
          formData.append("name", values.name);
          formData.append("description", values.description);
          formData.append("vpt_number", values.vpt_number);
          formData.append("ul_number", values.ul_number);
          formData.append("price", values.price);
          formData.append("retail_price", values.retail_price);
          formData.append("install_cost", values.install_cost);
          formData.append("formula_cost", values.formula_cost);
          formData.append("s_price", values.s_price);
          formData.append("start", values.start);
          formData.append("end", values.end);
          formData.append("tags", values.tags);
          formData.append("unit", values?.unit?.id);
          formData.append("unit_qty", values.unit_qty);
          formData.append("category", values.category.id);
          formData.append("sub_category", values.sub_category.id);
          formData.append("workflow", values.workflows?.id);
          formData.append("recipe", values.recipe_id?.id);
          formData.append("pf_cost_without_markup", values.recipe_id?.expected_cost || 0);   
          formData.append("inHouse", inHouse);
          formData.append("pf_retail_markup", values.pf_retail_markup);
          formData.append("isTrafficCatalog", values.isTrafficCatalog);
          formData.append("markup", values.markup);
          formData.append("sub_contract_price", values.sub_contract_price);
          formData.append("in_stock_no", values.in_stock_no);
          formData.append("prod_inhouse_no", values.prod_inhouse_no);
          formData.append("taxCodeId", values.taxCodeId);
          formData.append("taxCode", values.taxCode);
          formData.append("facility_id", values.facility_id?.id || '');
          formData.append("install_labour_quantity", values?.install_labour_quantity || 0);
          formData.append("expected_cost", values?.expected_cost || 0);
          formData.append("lead_time", values.lead_time);
          formData.append("bin_location", values.bin_location || '');
          if (values.vendor) {
            formData.append("vendor_id", values.vendor);
          }
          formData.append("productQuickbookId", product.quickbookId);
          /*******************************************************************************************************/
          //Displaying formdata in console

          // console.log("Updation - Form data : ");
          // for (var pair of formData.entries()) {
          //   console.log(pair[0] + ' - ' + pair[1]);
          // }
          /*******************************************************************************************************/
          let editedProductData = null;
          try {
            const response = await axios.post(`${REST_API_END_POINT}product/update-product?id=${prodId}`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
            console.log("response.data : ", response.data);
            if (response.data.status === 1) {
              enqueueSnackbar('Catalog has been updated successfully!', { variant: 'success' });
              editedProductData = response?.data?.product || null;
              // EditEstimateJob / EditDesignJob (editProduct): update-product payload omits
              // recipe expected_* fields used by "Product formula cost Each".
              if (editProduct && editedProductData && values.recipe_id) {
                editedProductData = {
                  ...editedProductData,
                  expected_material_cost_with_markup:
                    values.recipe_id?.expected_material_cost_with_markup,
                  expected_service_cost_with_markup:
                    values.recipe_id?.expected_service_cost_with_markup,
                  expected_install_labor_cost_with_markup:
                    values.recipe_id?.expected_install_labor_cost_with_markup ??
                    values.recipe_id?.install_labour_cost_with_markup,
                }
              }
              // If browser back initiated the submit, go back only after a successful save.
              if (shouldGoBackAfterSave) {
                allowBrowserBackRef.current = true;
                setTimeout(() => {
                  window.history.back();
                }, 0);
                return;
              }
            }
            else if ((response.data.status === 2) ||
              (response.data.status === 0) ||
              (response.data.status === 3) ||
              (response.data.status === 406) ||
              (response.data.status === 500)) {
              enqueueSnackbar(response.data.message, { variant: 'error' });
            }
            else {
              enqueueSnackbar('Server error', { variant: 'error' });
            }
          } catch (error) {
            enqueueSnackbar('Error in updating catalog', { variant: 'error' });
            console.error("Axios request failed:", error.message);
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
              console.error("Response headers:", error.response.headers);
            } else if (error.request) {
              console.error("No response received. Request details:", error.request);
            } else {
              console.error("Error setting up the request:", error.message);
            }
          }
          resetForm();
          setSubmitting(false);
          // navigate(PATH_DASHBOARD.products.main,{state:{
          //   in_house:inHouse?'in_house':'sub_contract'
          // }});
          if (editProduct && onClose) {
            onClose(selectedProductForCatalog?.id, false, editedProductData);
          }else{
            navigate(PATH_DASHBOARD.products.main,{state:{
              in_house:isTrafficCatalog ? 1 : selectedTab === 'in_stock_catalog' ? 4 : selectedTab === 'client_owned_catalog' ? 5 : selectedTab === 'estimate_catalog' ? 7 : selectedTab === 'split_catalog' ? 6 : inHouse ? true : false,listPage: location.state?.listPage,
              rowsPerPage: location.state?.rowsPerPage,
              scrollToProductId: prodId
            }});
          }
        // }
      } catch (error) {
        console.error("Updation error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
      finally {
        autoSaveThenGoBackRef.current = false;
      }
    }
  });

  const { errors, values, touched, handleSubmit,handleChange, isSubmitting, setFieldValue, getFieldProps } = formik;
  console.log('values++++++++ 1', values)

  // Re-bind category after async loads (options list + sub-category parent category metadata)
  useEffect(() => {
    if (!product?.id) {
      isCategoryInitializedRef.current = false;
      return;
    }
    const resolvedCategory = resolveAssignedCategoryOption(categoryData, product, allSubCatData);
    if (!resolvedCategory) return;

    setCategoryData((prev) => {
      if (!Array.isArray(prev) || prev.some((item) => Number(item.id) === Number(resolvedCategory.id))) {
        return prev;
      }
      return [...prev, resolvedCategory].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
    });

    if (!isCategoryInitializedRef.current) {
      setFieldValue('category', resolvedCategory);
      isCategoryInitializedRef.current = true;
    }
  }, [
    product?.id,
    product?.category_id,
    product?.sub_category_id,
    product?.category_name,
    categoryData,
    allSubCatData,
    setFieldValue,
    values.category,
  ]);

  const isFormulaFieldLoading = useCallback(
    (fieldKey) => Boolean(formulaFieldLoading[fieldKey]),
    [formulaFieldLoading],
  );

  const getFormulaFieldTextFieldProps = useCallback((fieldKey, { helperText, disabled = false } = {}) => {
    const isLoading = isFormulaFieldLoading(fieldKey);
    return {
      disabled: disabled || isLoading,
      helperText: isLoading ? 'Updating…' : helperText,
      InputProps: isLoading
        ? {
            endAdornment: (
              <InputAdornment position="end">
                <CircularProgress color="inherit" size={18} />
              </InputAdornment>
            ),
          }
        : undefined,
    };
  }, [isFormulaFieldLoading]);

  useEffect(() => () => setFormulaFieldLoading({}), []);

  // Keep latest formik instance for popstate handler without re-registering listeners
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  const restoreBackGuardEntry = useCallback(() => {
    const st = window.history.state || {};
    window.history.pushState(
      { ...st, __edit_products_back_guard: true },
      '',
      window.location.href,
    );
  }, []);

  // Close dialog + stay on page
  const handleBackConfirmClose = useCallback(() => {
    setOpenBackConfirmDialog(false);
    restoreBackGuardEntry();
    backConfirmInProgressRef.current = false;
  }, [restoreBackGuardEntry]);

  // No = go back normally (no auto-save)
  const handleBackConfirmNo = useCallback(() => {
    setOpenBackConfirmDialog(false);
    autoSaveThenGoBackRef.current = false;
    allowBrowserBackRef.current = true;
    setTimeout(() => {
      window.history.back();
    }, 0);
    backConfirmInProgressRef.current = false;
  }, []);

  // Yes = auto-save then go back (after success)
  const handleBackConfirmYes = useCallback(async () => {
    setOpenBackConfirmDialog(false);
    autoSaveThenGoBackRef.current = true;
    try {
      await formikRef.current?.submitForm?.();
    } finally {
      if (autoSaveThenGoBackRef.current) autoSaveThenGoBackRef.current = false;
      if (!allowBrowserBackRef.current) restoreBackGuardEntry();
      backConfirmInProgressRef.current = false;
    }
  }, [restoreBackGuardEntry]);

  // Intercept browser back button: confirm -> auto-save -> go back on success
  useEffect(() => {
    const currentState = window.history.state || {};
    if (!currentState?.__edit_products_back_guard) {
      window.history.pushState(
        { ...currentState, __edit_products_back_guard: true },
        '',
        window.location.href,
      );
    }

    const handlePopState = () => {
      if (allowBrowserBackRef.current) return;
      if (backConfirmInProgressRef.current) return;
      backConfirmInProgressRef.current = true;
      setOpenBackConfirmDialog(true);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // Initialize install labor cost for split catalog (after formik initialization)
  useEffect(() => {
    console.log('useEffect triggered:', {
      inhouse: product?.inhouse,
      selectedTab,
      facility_id: product?.facility_id,
      installLabourDataLength: otherInstallationSplitInstallLabour.length,
      currentInstallLaborCost: values.install_labour_cost_with_markup
    });

    if ((product?.inhouse === 6 || selectedTab === 'split_catalog') && product?.facility_id && otherInstallationSplitInstallLabour.length > 0) {
      const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
        item => item.facility_id == product.facility_id
      );
      
      console.log('Filtered install labour:', filteredInstallLabour);
      
      if (filteredInstallLabour.length > 0) {
        const installLaborCost = filteredInstallLabour[0].total_cost;
        console.log('Setting install labor cost:', installLaborCost);
        setFieldValue('install_labour_cost_with_markup', installLaborCost);
        
        // Calculate install_cost based on quantity and labor cost
        const quantity = product?.install_labour_quantity || 0;
        const totalInstallCost = installLaborCost * quantity;
        console.log('Setting install cost:', totalInstallCost);
        setFieldValue('install_cost', totalInstallCost);
      }
    }
  }, [product?.facility_id, otherInstallationSplitInstallLabour, product?.inhouse, selectedTab, product?.install_labour_quantity, setFieldValue, values.install_labour_cost_with_markup]);

  // Update recipe_id when recipes are loaded (handles slow API calls)
  // NOTE: We only set the initial value once, so user selections from the Autocomplete aren't overridden.
  useEffect(() => {
    ////
    let new_Recipe_id = newRecipeID || product?.recipe_id
    if (recipe?.length > 0 && new_Recipe_id) {
      const foundRecipe = recipe?.find((data) => data?.id === new_Recipe_id);
      // Only set initial recipe when form still has no value
      // if (foundRecipe && (!values?.recipe_id || values?.recipe_id?.id !== product?.recipe_id)) {
      if (foundRecipe && !values?.recipe_id) {
        setFieldValue('recipe_id', foundRecipe);
        // Also update related fields
        setFieldValue('s_price', foundRecipe?.expected_material_cost_with_markup || 0);
        setFieldValue('markupPrice', foundRecipe?.expected_service_cost_with_markup || 0);
        // Keep Formula Cost = Product Cost (Retail) + Install Labor (same as formula select/refresh)
        // BACKUP: if (foundRecipe?.expected_cost || foundRecipe?.expected_material_cost_with_markup) {
        // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
        if (foundRecipe?.expected_cost || foundRecipe?.expected_material_cost_with_markup || foundRecipe?.expected_service_cost_with_markup || foundRecipe?.install_labour_cost_with_markup || foundRecipe?.expected_cost_with_markup) {
          const totalRetailCost = product?.inhouse === 6
            ? (foundRecipe?.expected_cost || 0)
            : ((foundRecipe?.expected_material_cost_with_markup || 0)
              + (foundRecipe?.expected_service_cost_with_markup || 0)
              + (foundRecipe?.install_labour_cost_with_markup || 0));
          setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2));
        }
      }
    }
  // }, [recipe, product?.recipe_id, values?.recipe_id, setFieldValue]);
  }, [recipe, product?.recipe_id, setFieldValue]);

  // Modal-from-estimate: after async recipe bind, keep Actual Retail / Install from saved catalog
  // (independent Edit Catalog page already initializes these correctly from product).
  const appliedCatalogPricesRef = useRef(null);
  useEffect(() => {
    if (!product?.id) return;
    if (appliedCatalogPricesRef.current === product.id) return;
    // Wait until recipe options are ready so we run after the recipe bind effect above
    if (product?.recipe_id && (!recipe?.length || !values?.recipe_id)) return;

    appliedCatalogPricesRef.current = product.id;

    const sourceActual =
      product.actual_retail_price ??
      selectedProductForCatalog?.original_actual_retail_price ??
      selectedProductForCatalog?.actual_retail_price;
    if (sourceActual != null && sourceActual !== '') {
      const actual = parseFloat(sourceActual);
      if (Number.isFinite(actual)) {
        // Actual Retail Price must not be less than Product Cost (Retail)
        const materialCost = typeof values?.s_price === 'number' ? values.s_price : 0;
        const serviceCost = typeof values?.markupPrice === 'number' ? values.markupPrice : 0;
        const productCostRetail = (product?.inhouse === 6 || selectedTab === 'split_catalog')
          ? (Number(values?.formula_cost) || 0)
          : (materialCost + serviceCost);
        const formulaCost = Number(values?.formula_cost) || (productCostRetail + (
          (product?.inhouse === 6 || selectedTab === 'split_catalog')
            ? 0
            : Number(values?.recipe_id?.install_labour_cost_with_markup || 0)
        ));
        setFieldValue(
          'retail_price',
          clampActualRetailToProductCost(actual, productCostRetail, formulaCost)
        );
      }
    }
    const sourceInstall =
      product.install_cost ??
      selectedProductForCatalog?.original_install_cost ??
      selectedProductForCatalog?.install_cost;
    if (sourceInstall != null && sourceInstall !== '') {
      const install = parseFloat(sourceInstall);
      if (Number.isFinite(install)) {
        // Actual Install Price must not be less than Install Labor Cost
        const recipeForInstall = values?.recipe_id;
        const installLaborCost = recipeForInstall
          ? ((product?.inhouse === 6 || selectedTab === 'split_catalog')
              ? Number(recipeForInstall?.expected_install_labor_cost || 0)
              : Number(recipeForInstall?.install_labour_cost_with_markup || 0))
          : 0;
        setFieldValue('install_cost', Number(Math.max(
          Number(install.toFixed(2)),
          Number((installLaborCost || 0).toFixed(2))
        ).toFixed(2)));
      }
    }
  }, [
    product?.id,
    product?.recipe_id,
    product?.actual_retail_price,
    product?.install_cost,
    selectedProductForCatalog?.original_actual_retail_price,
    selectedProductForCatalog?.actual_retail_price,
    selectedProductForCatalog?.original_install_cost,
    selectedProductForCatalog?.install_cost,
    recipe,
    values?.recipe_id,
    setFieldValue,
  ]);

  const handleWorkflowCreated = async (newWorkflow) => {
    setOpenWorkflowModal(false);
    
    // Fetch workflows and find the new one
    try {
      const res = await axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`)
      if (res?.data?.result) {
        // Sort alphanumerically by name
        const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setWorkflows(sortedWorkflows);
        
        const newWorkflowData = sortedWorkflows.find(r => r.id === newWorkflow);
        if (newWorkflowData) {
          setFieldValue('workflows', newWorkflowData);
        }
      }
    } catch (error) {
      console.error('Error fetching workflows:', error);
    }
  }

//   const validateForm = async () => { 
//   try {
//     await NewUserSchema.validate(values, { abortEarly: false });
//     console.log('Validation passed');
//   } catch (err) {
//     console.log('Validation Errors:', err.inner);
//   }
// };

// // Call the function
// validateForm();

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setSelectedFile(file);
        setFieldValue('avatarUrl', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );

  const handleThumbnailDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setSelectedThumbnail(file);
        setFieldValue('thumbnail', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );

  const UploadImage = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  }
  const handleCategory = async (data) => {
    console.log('data--',data);
    if (data) {
      setFieldValue('category', data)
      setFieldValue('sub_category', null)
      // setFieldValue('retail_price', '')
      // setFieldValue('price', '')
      // if(values?.s_price && data?.markup){
      //   const totalRetailCost = values?.s_price  + (values?.s_price * data?.markup / 100)
      //   setFieldValue('retail_price',totalRetailCost)
      // }else{
      //   setFieldValue('retail_price','')
      // }
      // if(values?.price && data?.markup){
      // const WholesalePrice = Number(values?.price)
      // const totalRetailCost = WholesalePrice  + (WholesalePrice * data?.markup / 100)
      //last back
      // if(values?.s_price && data?.markup){
      //   const totalRetailCost = values?.s_price  + (values?.s_price * data?.markup / 100)
      //   setFieldValue('retail_price',totalRetailCost.toFixed(2))
      // }else{
      //   setFieldValue('retail_price','')
      // }
      // if(values?.s_price && data?.wholesale_markup){
      //   const totalWholesaleCost = values?.s_price  + (values?.s_price * data?.wholesale_markup / 100)
      //   setFieldValue('price',totalWholesaleCost.toFixed(2))
      // }else{
      //   setFieldValue('price','')
      // }


      //previos
      // if(data?.markup >= 0){
      //   const totalRetailCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.markup / 100)
      //   setFieldValue('retail_price',totalRetailCost.toFixed(2))
      // }else{
      //   setFieldValue('retail_price','')
      // }
      // if(data?.wholesale_markup >= 0){
      //   const totalWholesaleCost = (values?.markupPrice || 0) + (values?.s_price || 0)  + ((values?.s_price || 0) * data?.wholesale_markup / 100)
      //   setFieldValue('price',totalWholesaleCost.toFixed(2))
      // }else{
      //   setFieldValue('price','')
      // }
      
      axios.post(`${REST_API_END_POINT}product/get-subcategory`, { id: data?.id })
        .then((res) => {
          // Sort alphanumerically by name
          const sortedSubCategories = [...(res.data.data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setSubCategory(sortedSubCategories)
          // setFieldValue('retail_price', '')
          // setFieldValue('price', '')
        })
        .catch((error) => {
          console.log(error)
        }).finally(()=>{
          // setFieldValue('retail_price', '')
          // setFieldValue('price', '')
        })
      
    }else{
      setFieldValue('category', null)
      setFieldValue('sub_category', null)
      // setFieldValue('retail_price','')
      // setFieldValue('price','')
      setSubCategory([])
    }
  }

  

  const handleSubCategory=async(data)=>{
   if(data){
    console.log('sub_category',data)
    setFieldValue('sub_category', data)
    
    // if(data.markup==null && data.wholesale_markup==null){
    //   // setFieldValue('retail_price', '')
    //   // setFieldValue('price', '')
    // }else{
    // if(data?.markup >= 0){
    //   const totalRetailCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.markup / 100)
    //   setFieldValue('retail_price',totalRetailCost.toFixed(2))
    // }else{
    //   setFieldValue('retail_price','')
    // }

    // if(data?.wholesale_markup >= 0){
    //   const totalWholesaleCost = (values?.markupPrice || 0) + (values?.s_price || 0)  + ((values?.s_price || 0) * data?.wholesale_markup / 100)
    //   setFieldValue('price',totalWholesaleCost.toFixed(2))
    // }else{
    //   setFieldValue('price','')
    // }
  // }
   }else{
    setFieldValue('sub_category', null)
    // setFieldValue('retail_price', '')
    // setFieldValue('price', '')

   }
  }
  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      setTags([...tags, inputValue.trim()])
      setInputValue('')
    }
  }

  const handleDelete = (tagToDelete) => {
    setTags((prevTags) => prevTags?.filter((tag) => tag !== tagToDelete))
  }
  const handleCancel=()=>{
    // navigate(PATH_DASHBOARD.products.main,{state:{
    //   in_house:inHouse?'in_house':'sub_contract'
    // }});
    if (editProduct && onClose) {
      onClose();
    }else{
      navigate(PATH_DASHBOARD.products.main,{state:{
        in_house:isTrafficCatalog ? 1 : selectedTab === 'in_stock_catalog' ? 4 : selectedTab === 'client_owned_catalog' ? 5 : selectedTab === 'split_catalog' ? 6 : selectedTab === 'estimate_catalog' ? 7 : inHouse ? true : false,listPage: location.state?.listPage,
        rowsPerPage: location.state?.rowsPerPage,
        scrollToProductId: prodId
      }});
    }
  }

  const handleRecipeCreated = async (newRecipe) => {
    setOpenRecipeModal(false);
    const fieldsToRefresh = getFormulaRefreshFieldKeys();
    setFormulaFieldsLoading(fieldsToRefresh, true);

    // Fetch recipes and find the new one
    try {
      const res = await axios.post(REST_API_END_POINT + 'product/get-all-recipes');
      if (res.data.status === 1) {
        const filteredData = res.data.recipes.filter((recipe) => 
          isTrafficCatalog ? recipe?.type === 2 : (product?.inhouse === 6 || selectedTab === 'split_catalog') ? recipe?.type === 3 : recipe?.type === 1
        ) || res.data.recipes;
        // Sort alphanumerically by name
        const sortedData = [...filteredData].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setRecipe(sortedData);
        
        const newRecipeData = sortedData.find(r => r.id === newRecipe.id);
        if (newRecipeData) {
          const receipe_id_new = newRecipeData?.id
          setNewRecipeID(receipe_id_new)     
          setFieldValue('recipe_id', newRecipeData);
          setFieldValue('s_price', newRecipeData?.expected_material_cost_with_markup || 0);
          setFieldValue('markupPrice', newRecipeData?.expected_service_cost_with_markup || 0);
          
          // BACKUP: if (newRecipeData?.expected_cost) {
          // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
          if (newRecipeData?.expected_cost || newRecipeData?.expected_material_cost_with_markup || newRecipeData?.expected_service_cost_with_markup || newRecipeData?.install_labour_cost_with_markup || newRecipeData?.expected_cost_with_markup) {
            const totalRetailCost = product?.inhouse === 6 ? (newRecipeData?.expected_cost || 0) : ((newRecipeData?.expected_material_cost_with_markup || 0) + (newRecipeData?.expected_service_cost_with_markup || 0) + (newRecipeData?.install_labour_cost_with_markup || 0));
            setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2));
            setFieldValue('expected_cost', newRecipeData?.expected_cost || 0);
            
            // Calculate Product cost (Retail) - same logic as the disabled field
            const materialServiceCost =
              parseFloat(newRecipeData?.expected_material_cost_with_markup || 0) +
              parseFloat(newRecipeData?.expected_service_cost_with_markup || 0);
            const productCostRetail = (product?.inhouse === 6 || selectedTab === 'split_catalog') 
              ? totalRetailCost 
              : clampActualRetailToProductCost(
                  product?.actual_retail_price,
                  materialServiceCost,
                  totalRetailCost
                );
            
            // Set Actual Retail Price from Product cost (Retail)
            setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
            
            // Get install labor quantity from recipe services (service_id == 10)
            if (newRecipeData?.services && Array.isArray(newRecipeData.services)) {
              const installLaborService = newRecipeData.services.find(service => service.service_id == 10);
              if ((product?.inhouse === 6 || selectedTab === 'split_catalog') && installLaborService && installLaborService.quantity) {
                setFieldValue('install_labour_quantity', installLaborService.quantity);
                // Set Actual Install Price from Install Labor Cost
                const installLaborCost = newRecipeData?.expected_install_labor_cost || 0;
                // BACKUP: setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                // Preserve saved Actual Install Price on formula refresh (same as retail_price Math.max)
                setFieldValue('install_cost', Number(Math.max(parseFloat(installLaborCost || 0), parseFloat(product?.install_cost || 0)).toFixed(2)));
              } else if (product?.inhouse !== 6 && selectedTab !== 'split_catalog') {
                // Set Actual Install Price from Install Labor Cost
                const installLaborCost = newRecipeData?.install_labour_cost_with_markup || 0;
                // BACKUP: setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                // Preserve saved Actual Install Price on formula refresh (same as retail_price Math.max)
                setFieldValue('install_cost', Number(Math.max(parseFloat(installLaborCost || 0), parseFloat(product?.install_cost || 0)).toFixed(2)));
              }
            }
            
            // Set retail_price with split percentage calculation for inHouse == 6 or split_catalog
            if ((product?.inhouse === 6 || selectedTab === 'split_catalog') && splitPercentage) {
              const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
              const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
              setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
            }
          }

          // Refetch workflows and match the associated workflow if present
          try {
            const workflowRes = await axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`);
            if (workflowRes?.data?.result) {
              const sortedWorkflows = [...(workflowRes.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
              setWorkflows(sortedWorkflows);

              const recipeWorkflowId = newRecipeData?.workflow_id || newRecipe?.workflow_id;
              if (recipeWorkflowId) {
                const matchedWorkflow = sortedWorkflows.find(w => w.id == recipeWorkflowId);
                if (matchedWorkflow) {
                  setFieldValue('workflows', matchedWorkflow);
                }
              }
            }
          } catch (workflowError) {
            console.error('Error fetching workflows during recipe creation:', workflowError);
          }
        }
      } else {
        enqueueSnackbar('Failed to refresh product formula data', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error fetching recipes:', error);
      enqueueSnackbar('Error refreshing product formula data', { variant: 'error' });
    } finally {
      setFormulaFieldsLoading(fieldsToRefresh, false);
    }
  }
  return (
    isLoading ? 
      <Stack alignItems='center' justifyContent='center'>
        <LoadingScreen />
      </Stack>
    :
    <Page title="Edit Catalog | Sign-Wise Solution">
      {loading?<Stack sx={{display:'flex',justifyContent:'center',alignItems:'center',alignContent:'center'}} >
      <LoadingScreen />
    </Stack>:
      <Container>
        {editProduct ? '' :
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs
            heading="Edit Catalog"
          /></Stack>}
 {timeMaterial? 
          <AddTimeAndMaterialProduct timeMaterial={timeMaterial}/>
          :
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Dialog
              open={openBackConfirmDialog}
              onClose={handleBackConfirmClose}
              aria-labelledby="back-autosave-dialog-title"
            >
              <DialogTitle id="back-autosave-dialog-title">Go back?</DialogTitle>
              <DialogContent>
                <Typography>
                  Do you want to auto save this Catalog before going back?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleBackConfirmYes}
                  color="primary"
                  variant="contained"
                >
                  Yes, Auto Save
                </Button>
                <Button onClick={handleBackConfirmNo} color="inherit">
                  No, Go Back
                </Button>
              </DialogActions>
            </Dialog>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
              {/* <Grid item xs={12} md={4}>
                <Card sx={{ py: 10, px: 3 }}>
                  {isEdit && (
                    <Label
                      color={values.status !== 'active' ? 'error' : 'success'}
                      sx={{ textTransform: 'uppercase', position: 'absolute', top: 24, right: 24 }}
                    >
                      {values.status}
                    </Label>
                  )}

                  <Box sx={{ mb: 5 }}>
                    <LabelStyle></LabelStyle>
                    <UploadAvatar
                      accept="image/*"
                      file={values.avatarUrl}
                      maxSize={1024 * 1024 * 1024}
                      onDrop={handleDrop}
                      error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      caption={
                        <Typography
                          variant="caption"
                          sx={{
                            mt: 2,
                            mx: 'auto',
                            display: 'block',
                            textAlign: 'center',
                            color: 'text.secondary'
                          }}
                        >
                          Allowed *.jpeg, *.jpg, *.png, *.gif
                          <br /> max size of {fData(14680064)}
                        </Typography>
                      }
                    />

                    <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                      {touched.avatarUrl && errors.avatarUrl}
                    </FormHelperText>

                  </Box>

                </Card>
              </Grid> */}
              <Grid item xs={12} md={10}>
              <Typography variant='h6' gutterBottom>
                  {/* {inHouse ? "In House" : "Sub Contract"} */}
                        {isTrafficCatalog
                          ? "Traffic Catalog"
                          : product?.inhouse === 4
                            ? "In Stock Catalog"
                          : product?.inhouse === 5
                            ? "Client Owned Catalog"
                            :product?.inhouse === 6
                            ? "Split Catalog"
                            :product?.inhouse === 7
                            ? "Estimate Catalog"
                            : inHouse
                              ? "Production Catalog"
                              : "Sub Contract"}
                  {/* {isTrafficCatalog ? "Traffic Catalog" : inHouse ? "In House" : "Sub Contract"} */}
                </Typography>
                {/* <Card sx={{ p: 10, margin: 'auto',height: 'fit-content' }}> */}
                <Card sx={{ p:5 ,margin: 'auto',height: '70vh', overflow: 'auto', bgcolor: 'background.paper',boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', }}>
                {/* <FormControlLabel
                    control={
                      <Switch
                        checked={inHouse}
                        onChange={() => { setInHouse(!inHouse) }}
                      />
                    }
                    label={inHouse ? "In House" : "Sub Contract"}
                  /> */}
                  <Stack spacing={3} sx={{ bgcolor: 'background.paper',boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', }}>
                          <Stack
                            key="product-info-header"
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{
                              position: 'sticky',
                              top: "-42px",
                              paddingTop: "17px",
                              zIndex: 2,  // Keeps it above other content
                              bgcolor: 'background.paper',
                              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                              paddingBottom: 2,
                              marginBottom: '2rem',  // Prevents overlap with the next section
                            }}
                          >
                      <TextField
                        fullWidth
                        label="Name"
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                      <TextField
                          fullWidth
                          label="SKU"
                          // type="number"
                          {...getFieldProps('vpt_number')}
                          // onKeyDown={(e) => {
                          //   const invalidKeys = ['ArrowUp', 'ArrowDown',  '-', 'e', '+'];
                          //   if (invalidKeys.includes(e.key)) {
                          //     e.preventDefault();
                          //   }
                          // }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                              </InputAdornment>
                            ),
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                          }}
                          // onWheel={(e) => {
                          //   e.preventDefault();
                          // }}
                          error={Boolean(touched.vpt_number && errors.vpt_number)}
                          helperText={touched.vpt_number && errors.vpt_number}
                          disabled={true}
                        /> 
                      <TextField
                        fullWidth
                        label="UL #"
                        {...getFieldProps('ul_number')}
                        onChange={handleChange}
                      />
                      </Stack>

                      {!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' && (
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            fullWidth
                            id="sub-contract-vendor"
                            options={vendors}
                            value={vendors?.find((option) => String(option.id) === String(values.vendor)) || null}
                            onChange={(event, newValue) => setFieldValue('vendor', newValue?.id ? String(newValue.id) : '')}
                            isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id ?? value)}
                            getOptionLabel={(option) => option.name || ''}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {(option?.syncWithQuickBook === 1 || option?.syncWithQuickbooks === 1) ? (
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                  ) : (
                                    <Avatar sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                  )}
                                  <span>{option.name}</span>
                                </Box>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Vendor"
                                error={Boolean(touched.vendor && errors.vendor)}
                                helperText={touched.vendor && errors.vendor}
                              />
                            )}
                          />
                        </Stack>
                      )}

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        label="Description"
                        {...getFieldProps('description')}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                      />
                    </Stack>
                    
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box sx={{ width: '100%' }}>
                        <LabelStyle>Thumbnail Image</LabelStyle>
                        <UploadSingleFile
                          accept="image/*"
                          fullImage={true}
                          allowDownload
                          file={values.thumbnail && values.thumbnail !== 'default.jpg' ? values.thumbnail : null}
                          maxSize={1024 * 1024 * 1024}
                          onDrop={handleThumbnailDrop}
                          error={Boolean(touched.thumbnail && errors.thumbnail)}
                          disabled={thumbnailLoading}
                          caption={
                            <Typography
                              variant="caption"
                              sx={{
                                mt: 2,
                                mx: 'auto',
                                display: 'block',
                                textAlign: 'center',
                                color: 'text.secondary'
                              }}
                            >
                              {thumbnailLoading ? 'Uploading...' : 'Allowed *.jpeg, *.jpg, *.png, *.gif'}
                              <br /> max size of {fData(14680064)}
                            </Typography>
                          }
                        />
                        <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                          {touched.thumbnail && errors.thumbnail}
                        </FormHelperText>
                      </Box>
                    </Stack>
                    
                   {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box sx={{ display: 'flex', gap: 1, width: '100%', alignItems: 'center' }}>
                      <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        options={recipe}
                        disabled={isFormulaFieldLoading('recipe_id')}
                        // Show spinner inside the open dropdown while formulas load
                        PaperComponent={({ children, ...paperProps }) => (
                          <Paper {...paperProps}>
                            {children}
                            {isRecipeLoading ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 1,
                                  py: 1.25,
                                  borderTop: '1px solid',
                                  borderColor: 'divider',
                                }}
                              >
                                <CircularProgress color="inherit" size={18} />
                                <Typography variant="caption" color="textSecondary">
                                  Loading formulas…
                                </Typography>
                              </Box>
                            ) : null}
                          </Paper>
                        )}
                        value={values.recipe_id ? recipe?.find(r => r.id === values.recipe_id?.id || r.id === values.recipe_id) : null}
                        // onChange={(event, newValue) => {
                        //   if(newValue){
                        //     setFieldValue('recipe_id', newValue);
                        //     setFieldValue('s_price', newValue?.expected_material_cost);
                        //     setFieldValue('markupPrice', newValue?.expected_total_service_cost)
                        //     if(values?.category?.wholesale_markup >= 0){
                        //       // const totalWholesaleCost = newValue?.expected_cost  + (newValue?.expected_cost * values?.category?.wholesale_markup / 100)
                        //       const totalWholesaleCost = ((newValue?.expected_material_cost || 0) + (newValue?.expected_total_service_cost || 0) ) + ((newValue?.expected_material_cost || 0) * values?.category?.wholesale_markup / 100)
                        //       setFieldValue('price',totalWholesaleCost.toFixed(2))
                        //     }else{
                        //       setFieldValue('price','')
                        //     }
                        //     if(values?.category?.markup >= 0){
                        //       // const totalRetailCost = newValue?.expected_cost  + (newValue?.expected_cost * values?.category?.markup / 100)
                        //       const totalRetailCost =((newValue?.expected_material_cost || 0) + (newValue?.expected_total_service_cost || 0) )  + ((newValue?.expected_material_cost || 0) * values?.category?.markup / 100)
                        //       setFieldValue('retail_price',totalRetailCost.toFixed(2))
                        //     }else{
                        //       setFieldValue('retail_price','')
                        //     }
                        //   }else{
                        //     setFieldValue('recipe_id', null);
                        //     setFieldValue('s_price', '');
                        //     setFieldValue('markupPrice', '');
                        //   }
                        // }}
                        onChange={(event, newValue) => {
                          if(newValue){
                            setFieldValue('recipe_id', newValue);

                            if(newValue?.workflow_id){
                              let defaultWorkflow = workflows?.find(val => val.id == newValue?.workflow_id)
                              setFieldValue('workflows', defaultWorkflow)
                            }
                            // setFieldValue('s_price', newValue?.expected_material_cost); previos
                            setFieldValue('s_price', newValue?.expected_material_cost_with_markup || 0);
                            // setFieldValue('markupPrice', newValue?.expected_total_service_cost) previos
                            setFieldValue('markupPrice', newValue?.expected_service_cost_with_markup || 0)
                            // 14-01-25
                            // if(values?.sub_category?.wholesale_markup >= 0 && values?.sub_category?.wholesale_markup !==null){
                            //   // const totalWholesaleCost = newValue?.expected_cost  + (newValue?.expected_cost * values?.category?.wholesale_markup / 100)
                            //   const totalWholesaleCost = ((newValue?.expected_material_cost || 0) + (newValue?.expected_total_service_cost || 0) ) + ((newValue?.expected_material_cost || 0) * values?.sub_category?.wholesale_markup / 100)
                            //   setFieldValue('price',totalWholesaleCost.toFixed(2))
                            // }else{
                            //   setFieldValue('price','')
                            // }
                          
//previos retail mrkup calculation based on sub cat
                            // if(values?.sub_category?.markup >= 0 && values?.sub_category?.markup !== null){
                            //   // const totalRetailCost = newValue?.expected_cost  + (newValue?.expected_cost * values?.category?.markup / 100)
                            //   const totalRetailCost =((newValue?.expected_material_cost || 0) + (newValue?.expected_total_service_cost || 0) )  + ((newValue?.expected_material_cost || 0) * values?.sub_category?.markup / 100)
                            //   setFieldValue('retail_price',totalRetailCost.toFixed(2))
                            // }else{
                            //   setFieldValue('retail_price','')
                            // }
                            // BACKUP: if(newValue?.expected_cost){
                            // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
                            if (newValue?.expected_cost || newValue?.expected_material_cost_with_markup || newValue?.expected_service_cost_with_markup || newValue?.install_labour_cost_with_markup || newValue?.expected_cost_with_markup) {
                              // const totalRetailCost = newValue?.expected_cost  + (newValue?.expected_cost * values?.category?.markup / 100)
                              // const totalRetailCost = product?.inhouse === 6 ? (newValue?.expected_cost|| 0) : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0) + (newValue?.install_labour_cost_with_markup || 0) )
                              const totalRetailCost =
                                Number(newValue?.expected_material_cost_with_markup || 0) +
                                Number(newValue?.expected_service_cost_with_markup || 0) +
                                Number(newValue?.install_labour_cost_with_markup || 0);
                              // setFieldValue('retail_price',totalRetailCost.toFixed(2))
                              setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2))
                              
                              // Calculate expected_cost (without markup)
                              const expectedCost = newValue?.expected_cost || 0;
                              setFieldValue('expected_cost', expectedCost);
                              
                              // Calculate Product cost (Retail) - same logic as the disabled field
                              const materialServiceCost =
                                parseFloat(newValue?.expected_material_cost_with_markup || 0) +
                                parseFloat(newValue?.expected_service_cost_with_markup || 0);
                              const productCostRetail = (product?.inhouse === 6 || selectedTab === 'split_catalog') 
                                ? totalRetailCost 
                                : clampActualRetailToProductCost(
                                    product?.actual_retail_price,
                                    materialServiceCost,
                                    totalRetailCost
                                  );
                              
                              // Set Actual Retail Price from Product cost (Retail)
                              setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
                              
                              // Get install labor quantity from recipe services (service_id == 10)
                              if (newValue?.services && Array.isArray(newValue.services)) {
                                const installLaborService = newValue.services.find(service => service.service_id == 10);
                                if ((product?.inhouse === 6 || selectedTab === 'split_catalog') && installLaborService && installLaborService.quantity) {
                                  setFieldValue('install_labour_quantity', installLaborService.quantity);
                                  // Set Actual Install Price from Install Labor Cost
                                  const installLaborCost = newValue?.expected_install_labor_cost || 0;
                                  // BACKUP: setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                                  // Preserve saved Actual Install Price on re-select (same as retail_price Math.max)
                                  setFieldValue('install_cost', Number(Math.max(parseFloat(installLaborCost || 0), parseFloat(product?.install_cost || 0)).toFixed(2)));
                                } else if (product?.inhouse !== 6 && selectedTab !== 'split_catalog') {
                                  // Set Actual Install Price from Install Labor Cost
                                  const installLaborCost = newValue?.install_labour_cost_with_markup || 0;
                                  // BACKUP: setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                                  // Preserve saved Actual Install Price on re-select (same as retail_price Math.max)
                                  setFieldValue('install_cost', Number(Math.max(parseFloat(installLaborCost || 0), parseFloat(product?.install_cost || 0)).toFixed(2)));
                                }
                              }
                              
                              // Set retail_price with split percentage calculation for inHouse == 6 or split_catalog
                              if ((product?.inhouse === 6 || selectedTab === 'split_catalog') && splitPercentage) {
                                const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
                                const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
                                setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
                              }
                            }else{
                              // setFieldValue('retail_price','')
                              setFieldValue('formula_cost','')
                              setFieldValue('expected_cost', 0)
                            }
                          }else{
                            setFieldValue('recipe_id', null);
                            setFieldValue('s_price', '');
                            setFieldValue('markupPrice', '');
                            // setFieldValue('retail_price', '');
                            setFieldValue('formula_cost','')

                          }
                        }}
                        renderInput={(params) => {
                          const recipeFieldProps = getFormulaFieldTextFieldProps('recipe_id', {
                            helperText: touched.recipe_id && errors.recipe_id,
                          });
                          return (
                            <TextField
                              {...params}
                              error={Boolean(touched.recipe_id && errors.recipe_id)}
                              helperText={recipeFieldProps.helperText}
                              label="Select a product formula"
                              disabled={params.disabled || recipeFieldProps.disabled}
                              InputProps={{
                                ...params.InputProps,
                                ...recipeFieldProps.InputProps,
                                endAdornment: (
                                  <>
                                    {recipeFieldProps.InputProps?.endAdornment}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          );
                        }}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                      {!(selectedTab === 'split_catalog' || product?.inhouse == 6) ? (
                        <Button
                          variant="outlined"
                          startIcon={<Icon icon={values.recipe_id ? editFill : plusFill} />}
                          onClick={() => setOpenRecipeModal(true)}
                          sx={{ 
                            mt: 0.5,
                            whiteSpace: 'nowrap',
                            minWidth: 'auto'
                          }}
                        >
                          {values.recipe_id ? 'Edit Formula' : 'Add Formula'}
                        </Button>
                      ):''}
                      </Box>
                      {/* <TextField
                        fullWidth
                        label="Material Cost(Retail)"
                        disabled={true}
                       
                        value={(typeof values?.s_price === 'number') ? values?.s_price.toFixed(2) : ''}

                        onChange={(event, newValue) => {
                          setFieldValue(s_price,newValue)
                        }}
                        // {...getFieldProps('s_price')}
                        error={Boolean(touched.s_price && errors.s_price)}
                        helperText={touched.s_price && errors.s_price}
                      /> */}
                    </Stack>}
                    {
                         product?.inhouse === 6 || selectedTab === 'split_catalog' ? 
                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                         <Autocomplete
                           sx={{ width: '100%' }}
                           id="combo-box-demo-type-single"
                           options={filteredOtherFacilityTypes || []}
                           {...getFieldProps('facility_id')}
                           onChange={(event, newValue) => {
                             setFieldValue('facility_id', newValue);
                             
                             // Filter and set install labor cost when facility_id changes
                             if (newValue && (product?.inhouse === 6 || selectedTab === 'split_catalog')) {
                               const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
                                 item => item.facility_id == newValue.id
                               );
                               
                               if (filteredInstallLabour.length > 0) {
                                 const installLaborCost = filteredInstallLabour[0].total_cost;
                                 setFieldValue('install_labour_cost_with_markup', installLaborCost);
                                 
                                 // Calculate install_cost based on quantity and labor cost
                                 const quantity = values.install_labour_quantity || 0;
                                 const totalInstallCost = installLaborCost * quantity;
                                 setFieldValue('install_cost', totalInstallCost);
                               }
                               
                               // Get split percentage from currentInstallationSplitManagementSettings for inHouse == 6 or split_catalog
                               if (product?.inhouse === 6 || selectedTab === 'split_catalog') {
                                 const splitSettings = currentInstallationSplitManagementSettings.find(
                                   setting => setting.id == currentFacilityId
                                 );
                                 
                                 if (splitSettings) {
                                   const facilitySplitPercentage = splitSettings.split_percentage || 0;
                                   setSplitPercentage(facilitySplitPercentage);
                                   
                                   // Update retail price with split percentage if formula_cost exists
                                   if (values.formula_cost) {
                                     const splitAmount = parseFloat(values.formula_cost) * (facilitySplitPercentage / 100);
                                     const finalRetailPrice = parseFloat(values.formula_cost) + splitAmount;
                                     setFieldValue('retail_price', finalRetailPrice);
                                   }
                                 }
                               }
                             } else if (!newValue && (product?.inhouse === 6 || selectedTab === 'split_catalog')) {
                               // Reset to initial state when facility type is unselected
                               setFieldValue('install_labour_cost_with_markup', null);
                               setFieldValue('install_cost', '');
                               setFieldValue('install_labour_quantity', 0);
                               
                               // Reset split percentage for inHouse == 6 or split_catalog
                               if (product?.inhouse === 6 || selectedTab === 'split_catalog') {
                                 setSplitPercentage(0);
                                 
                                 // Reset retail price if no facility is selected
                                 if (values.formula_cost) {
                                   setFieldValue('retail_price', values.formula_cost);
                                 }
                               }
                             }
                           }}
                           getOptionLabel={(option) => option?.label ?? ''}
                           isOptionEqualToValue={(option, value) => option?.id === value?.id}
                           renderInput={(params) => (
                             <TextField
                               required
                               {...params}
                               label="Choose Facility"
                               placeholder="Select facility"
                               error={Boolean(touched.facility_id && errors.facility_id)}
                               helperText={touched.facility_id && errors.facility_id}
                             />
                           )}
                         />
                       </Stack>
                         : ''
                       }
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* <TextField
                        fullWidth
                        required
                        // label='Service+Labor markup'
                        label='Service Cost(Retail)'
                        id="price"
                        type="text"
                        disabled
                        // {...getFieldProps('price')}
                        value={(typeof values?.markupPrice === 'number') ? values?.markupPrice.toFixed(2) : ''}


                        onChange={(event,newValue)=>{
                          setFieldValue('markupPrice',newValue)
                          // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // }
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                      /> */}

                      <TextField
                        fullWidth
                        required
                        label= 'Product cost (Retail)'
                        id="product_cost_retail"
                        type="text"
                        disabled
                        {...getFormulaFieldTextFieldProps('product_cost_retail')}
                        value={(() => {
                          // For split formulas (product?.inhouse === 6 or selectedTab === 'split_catalog'), use formula_cost
                          if (product?.inhouse === 6 || selectedTab === 'split_catalog') {
                            return values?.formula_cost ? Number(values.formula_cost).toFixed(2) : 0;
                          }
                          
                          // For other formulas, use the original calculation
                          const materialCost = typeof values?.s_price === 'number' ? values.s_price : 0;
                          // const serviceCost = typeof values?.markupPrice === 'number' ? values.markupPrice : 0;
                          // NEW
                          const serviceCost = Number(
                            values?.recipe_id?.expected_total_service_cost || 0
                          );
                          console.log('materialCost++++++++ 1', materialCost)
                          console.log('serviceCost++++++++ 1', serviceCost)
                          const totalCost = materialCost + serviceCost;
                          
                          return Number(totalCost).toFixed(2);
                        })()}
                        error={Boolean(touched.product_cost_retail && errors.product_cost_retail)}
                        helperText={touched.product_cost_retail && errors.product_cost_retail}
                      />

                      {(values?.recipe_id?.install_labour_cost_with_markup > 0 || values?.recipe_id?.expected_install_labor_cost > 0) && (
                        <TextField
                          fullWidth
                          label='Install Labor Cost'
                          id="install_labour_cost"
                          type="text"
                          disabled
                          {...getFormulaFieldTextFieldProps('install_labour_cost')}
                          value={(product?.inhouse === 6 || selectedTab === 'split_catalog') ? values?.recipe_id?.expected_install_labor_cost?.toFixed(2) || 0 : values?.recipe_id?.expected_install_labor_cost_with_markup?.toFixed(2) || 0}
                        />
                      )}

                     
                    </Stack>}
                       {(product?.inhouse === 6 || selectedTab === 'split_catalog') && (
                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                           <TextField
                             fullWidth
                             label={`Install Cost (${values.facility_id?.label || 'facility'})`}
                             id="install_labour_cost"
                             type="number"
                             disabled
                             {...getFormulaFieldTextFieldProps('install_labour_cost_with_markup')}
                             value={values.install_labour_cost_with_markup ? values.install_labour_cost_with_markup.toFixed(2) : 0}
                           />
                           <TextField
                            disabled={true}
                             fullWidth
                             label="Install Labor Quantity"
                             id="install_labour_quantity"
                             type="number"
                             inputProps={{ min: 0 }}
                             {...getFormulaFieldTextFieldProps('install_labour_quantity', { disabled: true })}
                             value={values.install_labour_quantity}
                             onChange={(event) => {
                               const quantity = parseFloat(event.target.value) || 0;
                               setFieldValue('install_labour_quantity', quantity);
                               
                               // Update install_cost based on quantity and labor cost
                               if (values.install_labour_cost_with_markup) {
                                 const totalInstallCost = values.install_labour_cost_with_markup * quantity;
                                 setFieldValue('install_cost', totalInstallCost);
                               } else {
                                 // Reset install_cost if no labor cost is set
                                 setFieldValue('install_cost', '');
                               }
                             }}
                             onWheel={(e) => e.target.blur()}
                             onKeyPress={(event) => {
                               if (event.key === '-') {
                                 event.preventDefault();
                               }
                             }}
                           />
                         </Stack>
                       )}

                                        {
                                          !inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' &&
                                        
                                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                                           <TextField
                                             fullWidth
                                             label="Price"
                                             type="number"
                                             value={values?.sub_contract_price || 0}
                                             onChange={(event, newValue) => {
                                               setFieldValue('sub_contract_price', event.target.value)
                                             }}
                                             onWheel={(e)=>e.target.blur()}
                                             onKeyPress={(event) => {
                                               if (event.key === '0' && event.target.value === '') {
                                                 event.preventDefault();
                                               }
                                               if (event.key === '-') {
                                                 event.preventDefault();
                                               }
                                              
                                             }}
                                             error={Boolean(touched.sub_contract_price && errors.sub_contract_price)}
                                             helperText={touched.sub_contract_price && errors.sub_contract_price}
                                            />
                    
                                                    <TextField
                                                      fullWidth
                                                      label="Markup (%)"
                                                      value={values?.markup || 0}
                                                      onChange={(event, newValue) => {
                                                        let value = event.target.value
                                                        let markUpData = parseFloat(value).toFixed(2)
                                                        setFieldValue('markup', value)
                                                      }}
                                                      type="number"
                                                      onWheel={(e)=>e.target.blur()}
                                                      onKeyPress={(event) => {
                                                     
                                                        if (event.key === '-') {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      error={Boolean(touched.markup && errors.markup)}
                                                      helperText={touched.markup && errors.markup}
                                                    />
                                         </Stack>
                                        }
                                        {
                                          !inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' &&
                                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                                           <TextField
                                             fullWidth
                                             label="Retail Price"
                                             type="number"
                                             sx={{width: '50%'}}
                                             disabled
                                             value={(() => {
                                               const price = Number(values?.sub_contract_price) || 0;
                                               const markup = Number(values?.markup) || 0;
                                               const retailPrice = price * (1 + markup / 100);
                                               return retailPrice ? retailPrice.toFixed(2) : '';
                                             })()}
                                             onWheel={(e)=>e.target.blur()}
                                            />
                                         </Stack>
                                        }

                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        fullWidth
                        required
                        label='PFC+Labor markup'
                        id="price"
                        type="text"
                        disabled
                        // {...getFieldProps('price')}
                        value={values.markupPrice}
                        onChange={(event,newValue)=>{
                          setFieldValue('markupPrice',newValue)
                          // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // }
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                      />
                     
                    </Stack> */}
                     {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && 
                     <>
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    {/* 14-01-25 */}
                      {/* <TextField
                        fullWidth
                        disabled
                        label="Wholesale Price"
                        // {...getFieldProps('price')}
                        value={values.price}
                        onChange={(event,newValue)=>{
                          setFieldValue('price',newValue)
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                        /> */}
                          {/* // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // } */}
                        
                      
                      <TextField
                        sx={{ width: product?.inhouse === 6 ? '50%' : '100%' }}
                        label='Formula Cost'
                        id="formula_cost"
                        disabled
                        {...getFormulaFieldTextFieldProps('formula_cost', {
                          helperText: touched.formula_cost && errors.formula_cost,
                        })}
                        value={((values?.recipe_id?.expected_material_cost_with_markup + values?.recipe_id?.expected_total_service_cost) + (values?.recipe_id?.expected_install_labor_cost_with_markup || 0)).toFixed(2)}
                        // value={values?.formula_cost}
                       
                        onChange={(event,newValue)=>{
                          setFieldValue('formula_cost',newValue)
                        }}
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.formula_cost && errors.formula_cost)}
                      />
                      {
                        (product?.inhouse === 6 || selectedTab === 'split_catalog') ?
                        <TextField
                          sx={{ width: '50%' }}
                          label="Outgoing Percentage %"
                          id="outgoing_percentage"
                          type="number"
                          disabled
                          value={splitPercentage ? splitPercentage : '0.00'}
                        />
                      :''
                      }
                      {/* <TextField
                        fullWidth
                        name="retail_price"
                        label='Retail Price'
                        id="retail_price"
                        type='number'
                        value={values?.retail_price}
                        onChange={handleChange}
                        inputProps={{ min: 0 }}
                        // onChange={(event,newValue)=>{
                        //   setFieldValue('retail_price',newValue)
                        // }}
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.retail_price && errors.retail_price)}
                        helperText={touched.retail_price && errors.retail_price}
                      /> */}
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        fullWidth
                        name="retail_price"
                        label='Actual Retail Price'
                        id="retail_price"
                        type='number'
                        disabled={selectedTab === 'split_catalog' || product?.inhouse === 6}
                        {...getFormulaFieldTextFieldProps('retail_price', {
                          disabled: selectedTab === 'split_catalog' || product?.inhouse === 6,
                          helperText: touched.retail_price && errors.retail_price,
                        })}
                        value={values?.retail_price ? Number(values.retail_price) : 0}
                        onChange={handleChange}
                        inputProps={{ min: 0 }}
                        // onChange={(event,newValue)=>{
                        //   setFieldValue('retail_price',newValue)
                        // }}
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.retail_price && errors.retail_price)}
                      />
                      <TextField
                        fullWidth
                        name="install_cost"
                        label='Actual Install Price'
                        id="install_cost"
                        type='number'
                        disabled={selectedTab === 'split_catalog' || product?.inhouse === 6}
                        {...getFormulaFieldTextFieldProps('install_cost', {
                          disabled: selectedTab === 'split_catalog' || product?.inhouse === 6,
                          helperText: touched.install_cost && errors.install_cost,
                        })}
                        value={values?.install_cost || 0}
                        onChange={handleChange}
                        inputProps={{ min: 0 }}
                        error={Boolean(touched.install_cost && errors.install_cost)}
                      />
                    </Stack>
                     </>
                    }
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="category-demo-box"
                        options={categoryData || []}
                        value={values.category}
                        // onChange={(event, newValue) =>setFieldValue('category', newValue)}
                        onChange={(event, newvalue) => {
                          if(newvalue){
                            console.log("Evente kkefekfekfefkefkef new value ",newvalue);
                            
                            setFieldValue('category', newvalue);
                            handleCategory(newvalue)
                          }else{
                            setFieldValue('category', null)
                            setFieldValue('sub_category', null)
                            // setFieldValue('retail_price','')
                            // setFieldValue('price','')
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.category && errors.category)}
                            helperText={touched.category && errors.category}
                            label="Select a category" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                        isOptionEqualToValue={(option, value) => Number(option?.id) === Number(value?.id) }

                      />
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="subcategory-combo-box"
                        options={subCategory || []}
                        value={values.sub_category}
                        onChange={(event, newValue) =>{
                    if(newValue){
                      handleSubCategory(newValue) 
                    }else{
                      // setFieldValue('retail_price','')
                      // setFieldValue('price','')
                         setFieldValue('sub_category', null)

                    }
                    }
                        }
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.sub_category && errors.sub_category)}
                            helperText={touched.sub_category && errors.sub_category}
                            label="Select a Sub Category" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                        isOptionEqualToValue={(option, value) => Number(option?.id) === Number(value?.id)}

                      />                     
                    </Stack>
                
                      <Stack direction={{ xs:'column',sm :'row'}} spacing={{ xs:3 , sm :2}}>
                        {/* <Autocomplete
                          fullWidth
                          id="combo-box-demo"
                          options={UNITS}
                          value={values.unit}
                          onChange={(event, newValue) =>{
                            setFieldValue('unit', newValue)
                            if(newValue && newValue?.id==4){
                              setFieldValue('unit_qty', '')
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} required
                              error={Boolean(touched.unit && errors.unit)}
                              helperText={touched.unit && errors.unit}
                              label="Select a unit" />
                          )}
                          getOptionLabel={(option) => option.name ? option.name : ''}
                        /> */}
                        {/* {((values?.unit) && (values?.unit?.id !== 4)) ?
                          <TextField
                            fullWidth
                            label={'Number of '+values?.unit?.name}
                            type="number"
                            onKeyPress={(event) => {
                              // console.log('errorFieldId------',errorFieldId)
                              if (event.key === '0' && event.target.value === '0' ) {
                                event.preventDefault();
                              }
                              if (event.key === '0' && event.target.value === '' ) {
                                event.preventDefault();
                              }
                              if (event.key === '-' ) {
                                event.preventDefault();
                              }
                              if (event.key === '.' ) {
                                event.preventDefault();
                              }
                            }}
                            {...getFieldProps('unit_qty')}                  
                            error={Boolean(touched.unit_qty && errors.unit_qty)}
                            helperText={touched.unit_qty && errors.unit_qty}
                          /> 
                        : null } */}
                         <Autocomplete
                        freeSolo
                        multiple
                        fullWidth
                        id="tags-outlined"
                        // options={tags}
                        options={[]}
                        value={tags || []}
                        onChange={(event, newValue) => setTags(newValue)}
                        inputValue={inputValue}
                        onInputChange={handleInputChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Tags"
                            onKeyDown={handleKeyDown}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((tag, index) => (
                            <Chip
                              key={index}
                              label={tag}
                              onDelete={() => handleDelete(tag)}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                      </Stack>
                      <Stack direction={{ xs:'column',sm :'row'}} spacing={{ xs:3 , sm :2}}>
                       <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        options={workflows}
                        value={values.workflows}
                        onChange={(event, newValue) => setFieldValue('workflows', newValue)}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        getOptionLabel={(option) => option?.name || ''}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params}
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows}
                            label="Select a production Workflow" />
                          )}
                        />
                        {(inHouse) ? (
                          <Button
                            variant="outlined"
                            startIcon={<Icon icon={values.workflows ? editFill : plusFill} />}
                            onClick={() => setOpenWorkflowModal(true)}
                            sx={{ 
                              mt: 0.5,
                              whiteSpace: 'nowrap',
                              minWidth: 'auto'
                            }}
                          >
                            {values.workflows ? 'Edit Workflow' : 'Add Workflow'}
                          </Button>
                        ):''}

                         
                        {/* {((product?.inhouse != 1 && product?.inhouse != 6)|| (product?.inhouse === 1 && product?.isTrafficCatalog === 1))&& (
                          <TextField
                            fullWidth
                            required
                            label="Stock"
                            {...getFieldProps('in_stock_no')}
                            onChange={(e) => {
                              const numericOnly = e.target.value.replace(/\D/g, '');
                              setFieldValue('in_stock_no', numericOnly);
                            }}
                            error={Boolean(touched.in_stock_no && errors.in_stock_no)}
                            helperText={touched.in_stock_no && errors.in_stock_no}
                          />
                        )} */}

                      </Stack>

                       <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                                            <Autocomplete fullWidth
                                              // sx={{ width: 400 }}
                                              id="combo-box-demo"
                                              options={avaTaxCategory || []}
                                              value={avaTaxCategory.find((item) => item.taxCodeId == values.taxCodeId) || null}
                                              onChange={(event, newvalue) =>{
                                                    if(newvalue){
                                                      setFieldValue('taxCodeId', newvalue.taxCodeId);
                                                      setFieldValue('taxCode', newvalue.taxCode);
                                                    }else{
                                                      setFieldValue('taxCodeId', null);
                                                      setFieldValue('taxCode', '');
                                                    }
                                              }}
                                              renderInput={(params) => (
                                                <TextField {...params} 
                                                  // error={Boolean(touched.category && errors.category)}
                                                  // helperText={touched.category && errors.category}
                                                  label="Select Avalara Tax Category" />
                                              )}
                                              getOptionLabel={(option) => option.description ? option.description : ''}
                      
                                            />
                                          
                                          </Stack>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                            <TextField
                              sx={{ width: { xs: '100%', sm: (product?.inhouse === 1 && !isTrafficCatalog) ? '100%' : '50%' } }}
                              label="Lead Time (Days)"
                              type="number"
                              value={values?.lead_time || ''}
                              onChange={(event) => {
                                const value = event.target.value;

                                // Allow only empty input or positive integers (no decimals, no negatives)
                                if (value === '' || (/^\d+$/.test(value) && Number(value) >= 0)) {
                                  setFieldValue('lead_time', value);
                                }
                              }}
                              onWheel={(e) => e.target.blur()} // prevent accidental scroll change
                              onKeyPress={(event) => {
                                // Disallow leading 0 as first character
                                if (event.key === '0' && event.target.value === '') {
                                  event.preventDefault();
                                }
                                // Disallow negative sign and decimal point
                                if (event.key === '-' || event.key === '.') {
                                  event.preventDefault();
                                }
                              }}
                              inputProps={{ min: 0, step: 1, pattern: '[0-9]*' }}
                              error={Boolean(touched.lead_time && errors.lead_time)}
                              helperText={touched.lead_time && errors.lead_time}
                            />
                            {!(product?.inhouse === 1 && !isTrafficCatalog) && (
                              <TextField
                                sx={{ width: { xs: '100%', sm: '50%' } }}
                                label="BIN Location"
                                type="text"
                                value={values?.bin_location || ''}
                                onChange={(event) => {
                                  setFieldValue('bin_location', event.target.value);
                                }}
                                error={Boolean(touched.bin_location && errors.bin_location)}
                                helperText={touched.bin_location && errors.bin_location}
                              />
                            )}
                      </Stack>

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Save Changes
                      </LoadingButton>
                      <Button variant="outlined"  onClick={handleCancel} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Stack>
                </Card>
                {Editproduct ? '' : (((product?.inhouse != 1 && product?.inhouse != 6)|| (product?.inhouse === 1 && product?.isTrafficCatalog === 1))? (

                  <>
                 <Grid container spacing={2} >
            <Tabs
              value={currentTab}
              scrollButtons="auto"
              variant="scrollable"
              allowScrollButtonsMobile
              // onChange={handleChangeTab}
              sx={{mt:2}}
            >
              {ACCOUNT_TABS.map((tab) => (
                <Tab sx={{
                  justifyContent: 'center',
                  overflow: 'visible'
                }}
                  disableRipple
                  key={tab.value}
                  label={
                    <Typography variant="overline">{capitalCase(tab.value)}</Typography>
                  }
                  icon={tab.icon}
                  value={tab.value}
                />
              ))}
            </Tabs>
            {ACCOUNT_TABS.map((tab) => {
              const isMatched = tab.value === currentTab;
              return isMatched &&
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
                  {currentTab == 'Finished Products' ?
                    <MaterialFinishedProducts  prodId={prodId} unitName={"unit"} unit={product?.unit} unitQty={1} expectedPrice={expectedPrice} vpt_number={product?.vpt_number} description={product?.description} hideMoveToPartial={true} isCatalog={true}/>
                    :
                    ""
                    // <MaterialPartialFinishedProducts prodId={prodId} unitName={unitName} unit={product?.unit} unitQty={unitQty} expectedPrice={values.price} vpt_number={product?.vpt_number}  description={product?.description}/>
                  }
                </Box>
            })}
          </Grid>
                  
             
                  <Card sx={{ p: 3, mt: 4 }}>
                  <Typography variant='h6' sx={{ mb: 2 }}>Catalog Stock Logs</Typography>
                  <Divider sx={{mb: 2}} />
                  {catalogStocks && catalogStocks.length > 0 ? (
                    <Timeline position="alternate">
                      {catalogStocks.map((item) => (
                        <TimelineItem key={item.id}>
                          <TimelineSeparator>
                            <MTimelineDot color='primary'><span className='ic--baseline-history' /></MTimelineDot>
                            <TimelineConnector />
                          </TimelineSeparator>
                          <TimelineContent>
                            <Paper
                              sx={{
                                p: 3,
                                bgcolor: 'grey.50012',
                                textAlign: 'left',
                              }}
                            >
                              <Typography variant="subtitle2">{item.catalog_log_message}</Typography>
                              <Stack direction='column' sx={{ mt: 0.5 }} spacing={0.4}>
                                <Typography variant="body2" sx={{ color: 'text.secondary', mb: -0.5 }}>
                                  Catalog: {item.product_name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                  Added by: {item.added_by_name}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                  {moment.unix(item.timestamp).format('DD MMM YYYY, hh:mm A')}
                                </Typography>
                              </Stack>
                            </Paper>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                    </Timeline>) : (
                    <Typography>No stock logs found.</Typography>
                  )}
                </Card>     </>) : '')}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      }
            
      </Container>}
      
      <Modal
        modalTitle={values.recipe_id ? "Edit Product Formula" : "Add Product Formula"}
        open={openRecipeModal}
        handleClose={() => setOpenRecipeModal(false)}
        width={1200}
      >
        <JobCost 
          fromSplitEstimate={false}
          formulaName={values.recipe_id?.name || null}
          onRecipeCreated={handleRecipeCreated}
          setRecipes={setRecipe}
          formulaTab={(() => {
            let tab = 'production';
            if (isTrafficCatalog) {
              tab = 'traffic';
            } else if (product?.inhouse == 6 || selectedTab === 'split_catalog') {
              tab = 'split';
            }
            return tab;
          })()}
          recipeId={values.recipe_id?.id || null}
          fromAddProductsEdit={true}
        />
      </Modal>
      <Modal
        modalTitle={values.workflows ? "Edit Workflow" : "Add Workflow"}
        open={openWorkflowModal}
        handleClose={() => setOpenWorkflowModal(false)}
        width={1200}
      >
        <AddNewProductionWorkFlow 
          fromProducts={true} 
          setOpenWorkflowModal={setOpenWorkflowModal} 
          selectedWorkflowId={values?.workflows?.id || null} 
          onWorkflowCreated={handleWorkflowCreated}
        />
      </Modal>
    </Page>
  );
}